import './Socials.scss'
import {FooterFacebookIcon, FooterInstagramIcon, instagramLogo, TelegramIcon, YoutubeIcon} from "../../assets/images";
import React from "react";


export default function Socials(props){
    const {contacts} = props

    return <div className={'social_items'}>
        <a href={contacts?.instagram} target={'_blank'}>
            {
                window.innerWidth > 1050 ? <FooterInstagramIcon/> : <img src={instagramLogo} alt=""/>
            }
        </a>
        <a href={contacts?.facebook} target={'_blank'}>
            <FooterFacebookIcon/>
        </a>
        <a href={contacts?.youtube} target={'_blank'}>
            <YoutubeIcon/>
        </a>
        <a href={contacts?.telegram} target={'_blank'}>
            <TelegramIcon/>
        </a>
    </div>
}